import React, { Suspense, lazy } from 'react';
import { useMediaPlayer } from '../../contexts_main/MediaPlayerContext';

const PersistentPlayer = lazy(() => import('./PersistentPlayer'));
const StreamPlayer = lazy(() => import('./StreamPlayer'));

function ActiveMediaPlayer({
  persistentPlayerComponent: PersistentPlayerComponent = PersistentPlayer,
  streamPlayerComponent: StreamPlayerComponent = StreamPlayer,
}) {
  const { currentMedia, mediaType, isVisible } = useMediaPlayer();

  if (!isVisible || !currentMedia) return null;

  const PlayerComponent = mediaType === 'stream'
    ? StreamPlayerComponent
    : PersistentPlayerComponent;

  return (
    <Suspense fallback={null}>
      <PlayerComponent />
    </Suspense>
  );
}

export default ActiveMediaPlayer;
